import { ReactNode } from "react";
import { makeStyles, mergeClasses, tokens } from "@fluentui/react-components";
import { useCommonStyles } from "./Styles/commonStyles";
import { useSpacingUtilities } from "../../utilities/useSpacingUtilities";
import { appTokens } from "./Styles/appTokens";

const useStyles = makeStyles({
    root: {
        width: '100%',
        boxSizing: 'border-box',
        maxHeight: '100%',
        maxWidth: '100%',
        //flexGrow: '1',
        //flexShrink: '1',
        //flexBasis: '0',
    },
    clickable: {
        cursor: 'pointer'
    },
    noWrap: {
        flexWrap: 'nowrap'
    },
    noGap: {
        gap: '0rem'
    },
    smallGap: {
        gap: '.25rem'
    },
    mediumGap: {
        gap: '.5rem'
    },
    largeGap: {
        gap: '1.5rem'
    },
    widthOrHeightSet: {
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: 'unset'
    },
    fullHeight: {
        height: '100%',
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: 'unset'
    },
    alignLeft: {
        alignItems: 'start'
    },
    alignRight: {
        alignItems: 'end'
    },
    alignCenter: {
        alignItems:'center',
    },
    border: {
        border: `1px solid ${appTokens.border.colors.brand}`,
    }
});
export type RowProps = {
    children?: ReactNode;
    className?: string;
    width?: string;
    minWidth?: string;
    maxWidth?: string;
    height?: string,
    minHeight?: string;
    maxHeight?: string;
    align?: 'left' | 'right' | 'center' | undefined;
    onClick?: () => void;
    noWrap?: boolean;
    noGap?: boolean;
    fullHeight?: boolean;
    gap?: 'small' | 'medium' | 'large';
    margin?: string;
    padding?: string;
    border?: boolean;
    flex?: string | number;
    flexWrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
    justifyContent?: 'start' | 'end' | 'center' | 'space-between' | 'space-around' | 'space-evenly';
    gridTemplate?: string;
}
export const Row = (props: RowProps) => {

    const { children, flex, className, width, minWidth, maxWidth, height, minHeight='fit-content', maxHeight, onClick, noWrap = false, flexWrap,justifyContent, gap = 'large', fullHeight = false, noGap = false, margin, padding, border, align, gridTemplate, ...otherProps } = props;

    //Hooks
    const spacing = useSpacingUtilities();

    //Styles
    const commonStyles = useCommonStyles();
    const styles = useStyles();
    const rowClasses = mergeClasses(
        commonStyles.utility.flexRow,
        styles.root,
        !!onClick && styles.clickable,
        !!noWrap && styles.noWrap,
        (width || minWidth || maxWidth || height || minHeight || maxHeight) && styles.widthOrHeightSet,
        gap == 'large' && styles.largeGap,
        gap == 'medium' && styles.mediumGap,
        gap == 'small' && styles.smallGap,
        ...spacing.getSpacingClasses(padding, margin),
        !!noGap && styles.noGap,
        !!fullHeight && styles.fullHeight,
        !!border && styles.border,
        align === 'left' && styles.alignLeft,
        align === 'right' && styles.alignRight,
        align === 'center' && styles.alignCenter,
        className,
    );

    return (
        <div className={rowClasses} style={{ flex,flexWrap,gridTemplate, justifyContent, width, minWidth, maxWidth, height, minHeight, maxHeight }} onClick={onClick} {...otherProps}>
            {children}
        </div>
    );
}